import React, { useEffect } from "react";
import { useAuth } from "./AuthProvider";

const Logout = (props) => {
  const auth = useAuth();
  return (
            <span className={props.className} onClick={() => auth.logOut()} >
              Logout
            </span>
  );
};

export default Logout;